<lib-ffd-note-header
  [note]="note()"
  [inEditMode]="inEditMode()"
  [isNoteSaving]="isNoteSaving()"
  [isNoteSaved]="isNoteSaved()"
  (editNote)="toggleEditMode()"
  (deleteNote)="onDeleteNoteClick()"
  (noteSave)="onNoteSave($event)"
  (cancelEditMode)="toggleEditMode()"
>
  <div class="relative">
    <div
      [id]="'noteContent' + note().id"
      (click)="toggleEditMode($event)"
      class="relative cursor-text whitespace-pre-line outline-none"
      [ngClass]="{
        'new-note-placeholder': !noteText.trim()
      }"
      [innerHTML]="noteText"
    ></div>
    @if (!noteText.trim().length) {
      <span class="pointer-events-none absolute left-0 top-0 text-text-light"
        >{{ 'notes_add_new_note_placeholder_text' | translate }} <svg-icon class="h-4 w-4" key="px-16-voice-v-2" size="sm"></svg-icon
      ></span>
    }
  </div>
</lib-ffd-note-header>
